/**
 * 业务日历模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const businessCalendar = {
      //页面初始化
      init() {
        return axios.get(`${Vue.prototype.$base.API_PATH}/businessdate/init`);
      },
      //页面数据加载
      info(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/businessdate/info`, { params: params});
      },
      //更新促销计划
      salePlanUpdate(params) {
        return axios.post(`${Vue.prototype.$base.API_PATH}/businessdate/edit`, params);
      },
      //促销计划列表
      salePlanList(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/businessdate/sale-plan-list`, { params: params});
      },
}

export default businessCalendar;



// WEBPACK FOOTER //
// ./src/api/businessCalendar.js